import { CommonContexts, INotification, UuiContexts } from '@epam/uui-core'

export const showNotification = (
  svc: CommonContexts<UuiContexts, any>,
  renderPropChild: (props: INotification) => React.ReactNode
) => {
  svc.uuiNotifications
    .show((props) => {
      return <>{renderPropChild(props)}</>
    })
    // TODO: this line is a temporary fix for [WKLGAS-407] Fix errors in browser console with notifications
    // remove after bug fix https://github.com/epam/UUI/issues/981
    .catch(() => null)
}
